import {
  useEffect,
  useState
} from "react";

import {
  useNavigate,
  useParams
} from "react-router-dom";

import API from "../../services/api";

function EditProduct() {

  const navigate =
    useNavigate();

  const { id } =
    useParams();

  const [categories,
    setCategories] =
    useState([]);

  const [form,
    setForm] =
    useState({
      category_id: "",
      name: "",
      sku: "",
      purchase_price: "",
      selling_price: "",
      stock: "",
      gst_percent: "",
      status: 1
    });

  useEffect(() => {
    loadCategories();
    loadProduct();
  }, []);

  const loadCategories =
    async () => {

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        const res =
          await API.get(
            "/categories",
            {
              headers: {
                Authorization:
                  `Bearer ${token}`
              }
            }
          );

        setCategories(
          res.data.categories || []
        );

      } catch (err) {
        console.log(err);
      }

    };

  const loadProduct =
    async () => {

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        const res =
          await API.get(
            `/products/${id}`,
            {
              headers: {
                Authorization:
                  `Bearer ${token}`
              }
            }
          );

        setForm(
          res.data
        );

      } catch (err) {
        console.log(err);
      }

    };

  const handleChange =
    (e) => {

      setForm({
        ...form,
        [e.target.name]:
          e.target.value
      });

    };

  const submit =
    async (e) => {

      e.preventDefault();

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        await API.put(
          `/products/${id}`,
          form,
          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }
        );

        navigate(
          "/admin/products"
        );

      } catch (err) {
        console.log(err);
      }

    };

  return (
    <div>

      <h1
        className="
        text-3xl
        md:text-4xl
        font-bold
        mb-6
        "
      >
        Edit Product
      </h1>

      <form
        onSubmit={submit}
        className="
        bg-[#111]
        rounded-2xl
        p-6
        space-y-5
        "
      >

        <div>

          <label className="block mb-2">
            Category
          </label>

          <select
            name="category_id"
            value={form.category_id}
            onChange={handleChange}
            required
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          >

            <option value="">
              Select Category
            </option>

            {categories.map(
              (cat) => (
                <option
                  key={cat.id}
                  value={cat.id}
                >
                  {cat.name}
                </option>
              )
            )}

          </select>

        </div>

        <div>

          <label className="block mb-2">
            Product Name
          </label>

          <input
            type="text"
            name="name"
            value={form.name || ""}
            onChange={handleChange}
            required
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          />

        </div>

        <div>

          <label className="block mb-2">
            SKU
          </label>

          <input
            type="text"
            name="sku"
            value={form.sku || ""}
            onChange={handleChange}
            required
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          />

        </div>

        <div
          className="
          grid
          md:grid-cols-2
          gap-4
          "
        >

          <div>

            <label className="block mb-2">
              Purchase Price
            </label>

            <input
              type="number"
              name="purchase_price"
              value={form.purchase_price || ""}
              onChange={handleChange}
              required
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            />

          </div>

          <div>

            <label className="block mb-2">
              Selling Price
            </label>

            <input
              type="number"
              name="selling_price"
              value={form.selling_price || ""}
              onChange={handleChange}
              required
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            />

          </div>

        </div>

        <div
          className="
          grid
          md:grid-cols-3
          gap-4
          "
        >

          <div>

            <label className="block mb-2">
              Stock
            </label>

            <input
              type="number"
              name="stock"
              value={form.stock || ""}
              onChange={handleChange}
              required
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            />

          </div>

          <div>

            <label className="block mb-2">
              GST %
            </label>

            <input
              type="number"
              name="gst_percent"
              value={form.gst_percent || ""}
              onChange={handleChange}
              required
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            />

          </div>

          <div>

            <label className="block mb-2">
              Status
            </label>

            <select
              name="status"
              value={form.status}
              onChange={handleChange}
              className="
              w-full
              p-3
              rounded-xl
              bg-black
              border
              border-yellow-500/20
              "
            >
              <option value={1}>
                Active
              </option>

              <option value={0}>
                Inactive
              </option>
            </select>

          </div>

        </div>

        <button
          type="submit"
          className="
          bg-yellow-500
          text-black
          px-6
          py-3
          rounded-xl
          font-semibold
          "
        >
          Update Product
        </button>

      </form>

    </div>
  );
}

export default EditProduct;